import { AlertCircle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/modal';
import { Typography } from '@/components/ui/typography';

interface MaxCardModalProps {
  open: boolean;
  onClose: () => void;
}

export function MaxCardModal({ open, onClose }: MaxCardModalProps) {
  return (
    <Modal
      open={open}
      onOpenChange={(v) => !v && onClose()}
      title={
        <div className="flex items-center gap-2">
          <AlertCircle
            className="h-5 w-5 text-destructive"
            aria-hidden="true"
          />
          Maximum Credit Card Limit Reached
        </div>
      }
    >
      <div>
        <Typography as="p" variant="body">
          Maximum limit of <span className="font-semibold">5 credit cards</span>{' '}
          reached. Please remove an existing card before adding a new one.
        </Typography>
        <div className="mt-4 flex justify-end">
          <Button type="button" onClick={onClose}>
            Okay
          </Button>
        </div>
      </div>
    </Modal>
  );
}
